import { render } from "./RgbaToHex.vue?vue&type=template&id=4dc87684&ts=true"
import script from "./RgbaToHex.vue?vue&type=script&lang=ts"
export * from "./RgbaToHex.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ultrapixel/Downloads/Programmierung/github/vuejs/rgba-to-hex/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__